export default __webpack_public_path__ + "static/media/1228.6359f75f.png";